import configDefault from "./config-default";

const config = {
  ...configDefault,
  code: "centralfit",
  companyName: "CentralFit",
  website: 'https://www.centralfitvincennes.fr/',
  favicon: '/centralfit-favicon.png',
  notifyChannel: 'vel-centralfit',
  htmlCustomCSS: "centralfit.scss",

  header: {
    title: "CentralFit",
    logo: "/centralfit-logo.png",
  },

  steps: {
    ...configDefault.steps,
    useSinglePageForm: true,
    userForm: {
      ...configDefault.steps.userForm,
      optins: {
        ...configDefault.steps.userForm.optins,
			}
    }
  },

  plans: {
    ...configDefault.plans,
    withBanner: true,
    topOfferTitle: "Meilleure offre",
    buttonTitle: "Je choisis cette offre",
    feesLabel: "Droits d'entrée",
    splitCounterAbo: true,
    order: (plans) => {
      return plans.sort((a, b) => a.vel_datas.position - b.vel_datas.position );
		}
  },

  options: {
    title: "Choisissez vos options",
    message: "",
    nextLabel: "Suivant",
  },

  confirmation: {
    ...configDefault.confirmation,
    backLabel: "RETOUR AU SITE"
  },

  promoCode: {
    label: "Avez-vous un code promo ?",
    placeholder: "VOTRE CODE ICI",
    confirmLabel: "Appliquer",
    verifyingLabel: "En cours de vérification"
  },

  payment: {
    ...configDefault.payment,
    paylineLabel: "Votre inscription est effective, il ne vous reste plus qu'à régler par carte la somme de ",
  },

  footer: {
    ...configDefault,
    logo: null,
    textLine: "",
    cgv: {
      link: "https://www.centralfitvincennes.fr/_files/ugd/0ee528_26d0937d68b0458e9956da8d374ff419.pdf",
      text: "Conditions Générales de Vente",
    },
  },

  theme: {
    ...configDefault.theme,
		checkColor: '#63442A'
	}

};

export default config;
